import api from '@edu-fe/api'
import Cookie from 'js-cookie'

export default {
  name: 'mine',

  learn: api.create(`/my/learn?userId=${Cookie.get('openid')}`),

  coupon: api.create(`/my/coupon?userId=${Cookie.get('openid')}`),

  course: api.create(`/my/courses/v2?userId=${Cookie.get('openid')}`),

  userInfo: api.create(`/user_info?userId=${Cookie.get('openid')}`),

  isVip: api.create('/vip'),

  getSendCourses: api.create('/my/send'),

  // 上报用户轨迹
  track: (data) => {
    return api.create('/track', { method: 'post', data })
  },
  deleteCourse: (courseId) => api.create(`/my/course/remove?courseId=${courseId}`, {
    method: 'POST'
  }),

  // reportLogin: (millSeconds) => api.create(`/report/login/time?millSeconds=${millSeconds}&type=normal`, {
  //   baseURL: 'https://mp-service.iciba.com/'
  // })
}
